import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/close.svg'
import _imports_1 from '../assets/circle.svg'
import _imports_2 from '../assets/circle-marked.svg'


const _hoisted_1 = { class: "pane" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "dot",
  src: _imports_1
}
const _hoisted_5 = {
  key: 1,
  class: "dot",
  src: _imports_2
}
const _hoisted_6 = { class: "text" }

import {  onMounted, reactive, watch } from "vue";

interface PrefixState {
    text: string;
    name: string;
    prefixs: PrefixItem[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'numberprefix',
  props: {
    text: {
        type: String,
        default: "",
    },
    value: {
        type: String,
        default: "",
    }
},
  emits: ["result"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const state = reactive<PrefixState>({
    text: props.text,
    name: "",
    prefixs: JSON.parse(props.text),
});
watch(() => props.text, (newVal, oldVal) => {
    if(newVal) {
        state.prefixs = JSON.parse(newVal)
    }
})

const onSelect = (item: PrefixItem) => {
    state.name = item.text
    emit("result", item.text, item.value)
}

const onCancel = () => {
    emit("result", '', '');
};

onMounted(() => { });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dialog",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "title" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text" }, "请选择号码前三位号段", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: onCancel
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.prefixs, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.value,
            onClick: ($event: any) => (onSelect(item))
          }, [
            (item.value != props.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1)
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "change",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
      }, "关闭")
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onCancel()))
    })
  ]))
}
}

})